
















import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { RssCSS } from "@/services/posts/postTypes/rss";
import { ImageItemCSS } from "@/services/posts/postTypes/image";

@Component
export default class ImageStyle extends Vue {
    @Prop() private itemStyle!: Style;
    // lifecycle hooks
    public created(): void {
    }

    // computed
    get model(): ImageItemCSS {
        return this.itemStyle.css
            ? (this.itemStyle.css as ImageItemCSS)
            : ({} as ImageItemCSS);
    }
}
